import { BaseModel } from '~/models/baseModel';

export class BalesByRegionModel extends BaseModel {
    public bales:number;
    public kg:number;
    public region:string;
}
